(function ($) {

    /** Counter effect */
    $(document).ready(function () {

        $.fn.isInViewport = function () {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        window.onload = function () {
            runAnimations();
        };

        // How long you want the animation to take, in ms
        const animationDuration = 2000;
        // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
        const frameDuration = 1000 / 60;
        // Use that to calculate how many frames we need to complete the animation
        const totalFrames = Math.round(animationDuration / frameDuration);
        // An ease-out function that slows the count as it progresses
        const easeOutQuad = t => t * (2 - t);

        // The animation function, which takes an Element
        const animateCountUp = el => {

            $(window).on('load resize scroll', function () {
                if ($(el).isInViewport() && $(el).text() == '0') {
                    let frame = 0;
                    const countTo = parseInt(el.dataset.number.replace(/,/g, ''), 10);

                    // Start the animation running 60 times per second
                    const counter = setInterval(() => {
                        frame++;
                        // Calculate our progress as a value between 0 and 1
                        // Pass that value to our easing function to get our
                        // progress on a curve
                        const progress = easeOutQuad(frame / totalFrames);
                        // Use the progress value to calculate the current count
                        const currentCount = Math.round(countTo * progress);

                        // If the current count has changed, update the element
                        if (parseInt(el.innerHTML, 10) !== currentCount) {
                            el.innerHTML = currentCount.toString().replace(/\B(?<!\.\d*)(?=(\d{0})+(?!\d))/g, ",");
                        }

                        // If we’ve reached our last frame, stop the animation
                        if (frame === totalFrames) {
                            clearInterval(counter);
                        }
                    }, frameDuration);
                }
            });
        };


        // Run the animation on all elements with a class of ‘countup’
        const runAnimations = () => {
            const countupEls = document.querySelectorAll('.countup');
            countupEls.forEach(animateCountUp);
        };
    });

    /** Logo slider */
    $('.main-logo-slider').slick({
        arrows: false,
        dots: false,
        swipeToSlide: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    /** Promoaction slider */
    $('.promo-slider').slick({
        arrows: true,
        dots: true,
        swipeToSlide: true,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.292351 8.50236L13.1385 15.9209C13.5257 16.1453 14.0107 15.8656 14.0107 15.4169L14.0107 0.582925C14.0107 0.135757 13.5257 -0.145498 13.1385 0.0788745L0.290771 7.49584C-0.0963519 7.72022 -0.0963519 8.27957 0.290771 8.50394L0.292351 8.50236Z" fill="#3E9B90"/></svg></button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7184 7.49763L0.872213 0.0790851C0.485089 -0.145289 0 0.134388 0 0.583136V15.4171C0 15.8642 0.485089 16.1455 0.872213 15.9211L13.72 8.50416C14.1071 8.27978 14.1071 7.72043 13.72 7.49606L13.7184 7.49763Z" fill="#3E9B90"/></svg></button>',
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    arrows: false,
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                }
            },
        ]
    });
    // $('.promo-slider').slick({
    //     arrows: true,
    //     dots: true,
    //     swipeToSlide: true,
    //     infinite: false,
    //     speed: 300,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.292351 8.50236L13.1385 15.9209C13.5257 16.1453 14.0107 15.8656 14.0107 15.4169L14.0107 0.582925C14.0107 0.135757 13.5257 -0.145498 13.1385 0.0788745L0.290771 7.49584C-0.0963519 7.72022 -0.0963519 8.27957 0.290771 8.50394L0.292351 8.50236Z" fill="#3E9B90"/></svg></button>',
    //     nextArrow: '<button type="button" class="slick-arrow slick-next"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7184 7.49763L0.872213 0.0790851C0.485089 -0.145289 0 0.134388 0 0.583136V15.4171C0 15.8642 0.485089 16.1455 0.872213 15.9211L13.72 8.50416C14.1071 8.27978 14.1071 7.72043 13.72 7.49606L13.7184 7.49763Z" fill="#3E9B90"/></svg></button>',
    //     responsive: [
    //         {
    //             breakpoint: 1600,
    //             settings: {
    //                 arrows: false,
    //             }
    //         },
    //         {
    //             breakpoint: 1400,
    //             settings: {
    //                 arrows: true,
    //             }
    //         },
    //         {
    //             breakpoint: 992,
    //             settings: {
    //                 arrows: false,
    //             }
    //         },
    //     ]
    // });

    /** Offer slider */
    $('.offer-slider').slick({
        arrows: false,
        dots: true,
        swipeToSlide: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

})
(jQuery);